var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c(
        "div",
        { staticClass: "flex flex-justify-between" },
        [
          _c("search-form", {
            attrs: {
              "form-items": _vm.searchFormItems,
              "initial-values": _vm.initVals,
              hasAdd: true,
            },
            on: {
              search: _vm.handleSearch,
              reset: _vm.handleReset,
              add: _vm.handleAdd,
            },
            scopedSlots: _vm._u([
              {
                key: "channelSelect",
                fn: function (ref) {
                  var formData = ref.formData
                  return [
                    _c("YdChannelSelect", {
                      attrs: {
                        placeholder: "请选择渠道名称",
                        params: {},
                        multiple: true,
                        collapseTags: true,
                        collapseTagsLimit: 1,
                        maxSelections: 5,
                      },
                      model: {
                        value: formData.name,
                        callback: function ($$v) {
                          _vm.$set(formData, "name", $$v)
                        },
                        expression: "formData.name",
                      },
                    }),
                  ]
                },
              },
              {
                key: "buttons",
                fn: function () {
                  return undefined
                },
                proxy: true,
              },
            ]),
          }),
          _c(
            "div",
            { staticClass: "btnGroup" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "has-permi",
                      rawName: "v-has-permi",
                      value: ["channel_confspec_btn"],
                      expression: "['channel_confspec_btn']",
                    },
                  ],
                  staticClass: "add",
                  staticStyle: { "margin-right": "40px" },
                  attrs: {
                    type: "primary",
                    icon: "el-icon-takeaway-box",
                    size: "mini",
                  },
                  on: { click: _vm.configOpen },
                },
                [_vm._v("\n        相关说明配置\n      ")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "add",
                  staticStyle: { "margin-right": "40px" },
                  attrs: {
                    type: "primary",
                    icon: "el-icon-takeaway-box",
                    size: "mini",
                  },
                  on: { click: _vm.operateLog },
                },
                [_vm._v("\n        操作日志\n      ")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "add",
                  staticStyle: { "margin-right": "40px" },
                  attrs: {
                    type: "primary",
                    icon: "el-icon-takeaway-box",
                    size: "mini",
                  },
                  on: { click: _vm.exportClick },
                },
                [_vm._v("\n        导出\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "page-table-coantainer" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.resData,
                border: true,
                "max-height": "650",
                size: "mini",
                "header-cell-style": { background: "#f5f7fa" },
                "span-method": _vm.objectSpanMethod,
                "cell-style": _vm.tableCellStyle,
              },
            },
            _vm._l(_vm.cols, function (item, index) {
              return _c("el-table-column", {
                key: index,
                attrs: {
                  fixed:
                    item.prop === "id" || item.prop === "name" ? true : false,
                  prop: item.prop,
                  label: item.label,
                  "min-width": item.width,
                  align: "center",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          item.prop === "shortUrl"
                            ? [
                                scope.row.shortUrl
                                  ? _c("div", [
                                      _c(
                                        "a",
                                        {
                                          staticStyle: { color: "#0a85f8" },
                                          attrs: {
                                            href: scope.row.shortUrl,
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(scope.row.shortUrl) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-download copy-icon",
                                        staticStyle: {
                                          "margin-left": "5px",
                                          cursor: "pointer",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.downLoadUrl(scope.row)
                                          },
                                        },
                                      }),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-document-copy copy-icon",
                                        staticStyle: {
                                          "margin-left": "5px",
                                          cursor: "pointer",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.copyUrl(
                                              scope.row.shortUrl
                                            )
                                          },
                                        },
                                      }),
                                    ])
                                  : _c("div", [_vm._v("-")]),
                              ]
                            : item.prop === "name"
                            ? [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          placement: "bottom",
                                          width: "250",
                                          trigger: "hover",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "infoList" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "title" },
                                              [_vm._v(_vm._s(scope.row.name))]
                                            ),
                                            _vm._l(
                                              scope.row.infoList,
                                              function (info) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: info.label,
                                                    staticClass: "info",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "label" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(info.label) +
                                                            ":"
                                                        ),
                                                      ]
                                                    ),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          info.value || "-"
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                        _c(
                                          "span",
                                          {
                                            attrs: { slot: "reference" },
                                            slot: "reference",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  scope.row.name.length > 10
                                                    ? scope.row.name.slice(
                                                        0,
                                                        10
                                                      ) + "..."
                                                    : scope.row.name
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              round: "",
                                              type:
                                                scope.row.status === 1
                                                  ? "warning"
                                                  : scope.row.status === 2
                                                  ? "success"
                                                  : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  scope.row.status === 1
                                                    ? "待生效"
                                                    : scope.row.status === 2
                                                    ? "生效中"
                                                    : "已失效"
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : item.prop === "operation"
                            ? [
                                !scope.row.isEmptyLinks
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "delete-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDeleteLink(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n              删除\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : item.prop === "manage"
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "operation-btns" },
                                  [
                                    scope.row.isFirstLink ||
                                    scope.row.isEmptyLinks
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "edit-btn",
                                            staticStyle: {
                                              "margin-right": "10px",
                                            },
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleEdit(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                编辑\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    scope.row.isFirstLink ||
                                    scope.row.isEmptyLinks
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "delete-btn",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleDeleteChannel(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                删除\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "has-permi",
                                            rawName: "v-has-permi",
                                            value: [
                                              "channel_view_commission_details",
                                            ],
                                            expression:
                                              "['channel_view_commission_details']",
                                          },
                                        ],
                                        staticStyle: { color: "#409eff" },
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.commissionOpen(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                查看佣金明细\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            : [
                                scope.row[item.prop] !== undefined &&
                                scope.row[item.prop] !== ""
                                  ? _c("span", { staticClass: "11111" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            item.formatter
                                              ? item.formatter(scope.row)
                                              : scope.row[item.prop]
                                          ) +
                                          "\n            "
                                      ),
                                    ])
                                  : _c("span", [_vm._v("-")]),
                              ],
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-box" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.page.page,
              "page-sizes": _vm.page.pageSizes,
              "page-size": _vm.page.size,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.page.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.fetchData,
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "page", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "page", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.page, "size", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.page, "size", $event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "CustomDialog",
        _vm._b(
          {
            attrs: { show: _vm.dialog.show },
            on: {
              "update:show": function ($event) {
                return _vm.$set(_vm.dialog, "show", $event)
              },
              submit: _vm.dialog.onSubmit,
            },
          },
          "CustomDialog",
          _vm.dialog,
          false
        ),
        [
          _vm.dialog.show
            ? _c(
                _vm.dialog.tag,
                _vm._b(
                  {
                    ref: "panel",
                    tag: "component",
                    attrs: { loading: _vm.dialog.loading, title: "" },
                  },
                  "component",
                  _vm.dialog,
                  false
                )
              )
            : _vm._e(),
        ],
        1
      ),
      _c("LogModel", {
        attrs: {
          visible: _vm.visible,
          active: "channelCode",
          extendHeads: _vm.extendHeads,
          needFormat: true,
          formatParams: _vm.formatParams,
          needFormatResult: true,
          formatResult: _vm.formatResult,
          customRequest: true,
          request: _vm.getLogList,
          operateTypeList: _vm.operateTypeList,
        },
        on: { close: _vm.handleClose },
      }),
      _c("qr-load", {
        attrs: { qrCodeData: _vm.qrCodeData },
        model: {
          value: _vm.qrVisible,
          callback: function ($$v) {
            _vm.qrVisible = $$v
          },
          expression: "qrVisible",
        },
      }),
      _vm.commission.show
        ? _c("Commission", {
            attrs: { show: _vm.commission.show, data: _vm.commission.data },
            on: { close: _vm.commissionClose },
          })
        : _vm._e(),
      _vm.config.show
        ? _c("ConfigDialog", {
            attrs: { show: _vm.config.show, data: _vm.config.data },
            on: { close: _vm.configClose },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }